import * as React from 'react';
const reducer = (state, action) => {
    switch (action.type) {
        case 'update':
            return {
                ...state,
                [action.contentPath]: action.value,
            };
        case 'bulk-update':
            return {
                ...state,
                ...action.changeset,
            };
    }
};
const Context = React.createContext(undefined);
export function useContentContainerState(initialState) {
    const context = React.useContext(Context);
    const [localState, localDispatch] = React.useReducer(reducer, context?.state || initialState || {});
    const dispatch = context?.dispatch || localDispatch;
    const update = React.useCallback((contentPath, value) => dispatch({
        type: 'update',
        contentPath,
        value,
    }), [dispatch]);
    const batchUpdate = React.useCallback((changeset) => dispatch({
        type: 'bulk-update',
        changeset,
    }), [dispatch]);
    return {
        state: context?.state || localState,
        update,
        batchUpdate,
        dispatch,
    };
}
export const SpawnContext = ({ data, children, }) => {
    const { state, dispatch } = useContentContainerState(data);
    return (React.createElement(Context.Provider, { value: { state, dispatch } }, children));
};
//# sourceMappingURL=context.js.map